import { Injectable } from '@angular/core';
import { SystemRoles, userManagementUrl } from '../../../../../constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SpecializedRolesListApiResponse } from '../dtos/responses/specialized-roles-list-response';
import { ICreateSpecializedRolesRequest } from '../dtos/requests/create-specialized-roles.request';
import { IUpdateSpecializedRolesRequest } from '../dtos/requests/update-specialized-roles.request';
import { IUpdateSpecializedRolesResponse } from '../dtos/responses/update-specialized-roles-response';
import { ICreateSpecializedRolesResponse } from '../dtos/responses/create-specialized-roles-response';
import { UserContextService } from '../../../auth-management/authentication/services/user-context.service';
import { DeprecatedPaginationParameters } from '../../../../../trash/shared/interfaces/shared-interfaces';

@Injectable({
    providedIn: 'root'
})
export class SpecializedRolesService {
    collectionUrl: string = `${userManagementUrl}/accounts/${UserContextService.getUserContext()?.accountId}/specialized-roles`;
    systemRolesUrl = `${userManagementUrl}/system-roles`;

    constructor(private http: HttpClient) {}

    getAll(params?: DeprecatedPaginationParameters): Observable<SpecializedRolesListApiResponse> {
        let paramsItem = new HttpParams();

        // Loop through the parameters and append them if defined
        if (params) {
            Object.keys(params).forEach(key => {
                const value = (params as any)[key];
                if (value !== undefined && value !== null && value !== '') {
                    paramsItem = paramsItem.append(this.mapParamKey(key), value);
                }
            });
        }

        // Return the HTTP GET call with the expected response type
        return this.http.get<SpecializedRolesListApiResponse>(`${this.collectionUrl}`, { params: paramsItem });
    }
    // Helper method to map parameter keys if needed (optional)
    private mapParamKey(key: string): string {
        const map: { [key: string]: string } = {
            sortColumn: 'SortColumn',
            sortOrder: 'SortOrder',
            searchField: 'SearchField',
            SearchKeyword: 'SearchKeyword',
            page: 'Page',
            pageSize: 'PageSize',
            order: 'Order',
            orderBy: 'OrderBy'
        };
        return map[key] || key;
    }

    // Create a new resource (POST)
    async create(request: ICreateSpecializedRolesRequest): Promise<Observable<ICreateSpecializedRolesResponse>> {
        return await this.http.post<ICreateSpecializedRolesResponse>(`${this.collectionUrl}`, request);
    }

    // Update a resource (PUT)
    async update(request: IUpdateSpecializedRolesRequest, id: number | string): Promise<Observable<IUpdateSpecializedRolesResponse>> {
        return await this.http.patch<IUpdateSpecializedRolesResponse>(`${this.collectionUrl}/${id}`, request);
    }

    getAllSystemRoles(params?: DeprecatedPaginationParameters): Observable<any> {
        let paramsItem = new HttpParams();

        // Loop through the parameters and append them if defined
        if (params) {
            Object.keys(params).forEach(key => {
                const value = (params as any)[key];
                if (value !== undefined && value !== null && value !== '') {
                    paramsItem = paramsItem.append(this.mapParamKey(key), value);
                }
            });
        }

        // Return the HTTP GET call with the expected response type
        return this.http.get<any>(`${userManagementUrl}/${SystemRoles}`, { params: paramsItem });
    }
}
